import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { useEffect, useState } from 'react';

import InvoicePendingRow from './InvoicePendingRow';
import axiosInstance from '../../api/axiosInstance';

function InvoicesPendingTable({accounts, invoicesPending, updatePendingInvoices, updatePayedInvoices}) {
   
    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Envoyée le</TableCell>
                        <TableCell>Destinataire</TableCell>
                        <TableCell>Numéro de facture</TableCell>
                        <TableCell align="right">Montant total (€)</TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {invoicesPending.length != 0 && invoicesPending.map((invoice) => (
                        <InvoicePendingRow key={invoice.id} invoice={invoice} accounts={accounts} updatePendingInvoices={updatePendingInvoices} updatePayedInvoices={updatePayedInvoices} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default InvoicesPendingTable;